// Event dates are calendar dates: an event remains visible on its final day.
export const isEventActive = (event, now = new Date()) => {
  const value = event?.endDate || event?.startDate;
  if (!value) return false;
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:T|$)/);
  if (!match) return false;
  const [, year, month, day] = match.map(Number);
  const end = new Date(year, month - 1, day);
  if (end.getFullYear() !== year || end.getMonth() !== month - 1 || end.getDate() !== day) {
    return false;
  }
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return end >= today;
};
